module.exports = __webpack_public_path__ + "img/VERS2.c2d93d31.png";